import { qs } from './utils.js';
import { CFG } from './config.js';
import { state } from './state.js';

export function buildPayload (container) {
    const form = qs(container, '.book__clientInformation form');
    const fd = form ? new FormData(form) : new FormData();
    const vetItem = qs(container, '#uploadList .book__uploadItem');
    const veteranFileId = vetItem?.dataset?.fileId || state.veteranFileId || null;

    return {
        state: state.stateCode,
        patientType: state.patientType,
        plan: state.plan,
        isVeteran: !!state.isVeteran,
        hasVeteranFile: !!state.hasVeteranFile,
        veteranFileId,

        date: state.dateISO,
        time: state.timeSlot,
        priceText: state.priceText,
        priceCents: state.priceCents,

        reminder: state.reminder,
        firstName: fd.get('firstName') || '',
        lastName: fd.get('lastName') || '',
        email: fd.get('email') || '',
        phone: fd.get('phone') || '',
        note: fd.get('note') || ''
    };
}